import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  Input,
  Button,
} from '@pearsontechnology/aero-components';

import { ModalContent, ModalActions } from 'components/Modal';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { commandIamTeamCreate } from 'containers/ConnectionManager/actions';

import {
  FormField,
} from './styles';
import messages from './messages';

class CreateTeamModal extends React.Component {
  state = {
    name: '',
    description: '',
    isValid: false,
    validationFields: {
      name: true,
    },
  };

  onChangeInput(key, value) {
    this.setState({
      [key]: value,
    }, this.validate);
  }

  onSubmitCreateTeam = () => {
    const { createTeam } = this.props;
    const { name, description } = this.state;

    createTeam({
      name,
      description,
    });
  };

  validate() {
    /* eslint no-param-reassign: ["error", { "props": false }] */
    const validationFields = _.reduce(this.state.validationFields, (fields, value, key) => {
      fields[key] = !!this.state[key].length;
      return fields;
    }, {});

    const isValid = !Object.values(validationFields).includes(false);

    this.setState({
      isValid,
      validationFields,
    });
  }

  render() {
    const { isValid, validationFields } = this.state;

    return (
      <React.Fragment>
        <ModalContent>
          <FormField>
            <Input
              label={intl.formatMessage(messages.name)}
              placeholder={intl.formatMessage(messages.name)}
              feedback={!validationFields.name ? intl.formatMessage(messages.nameValidationMessage) : ''}
              onChange={(e) => this.onChangeInput('name', e.target.value.trim())}
            />
          </FormField>
          <FormField>
            <Input
              label={intl.formatMessage(messages.description)}
              placeholder={intl.formatMessage(messages.description)}
              onChange={(e) => this.onChangeInput('description', e.target.value.trim())}
            />
          </FormField>
        </ModalContent>
        <ModalActions>
          <Button primary onClick={this.onSubmitCreateTeam} disabled={!isValid} >{intl.formatMessage(messages.createTeam)}</Button>
        </ModalActions>
      </React.Fragment>
    );
  }
}

CreateTeamModal.propTypes = {
  createTeam: PropTypes.func,
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { onCreated } = ownProps;

  return {
    createTeam: (team) => {
      const callbacks = [onCreated];

      return dispatch(commandIamTeamCreate(team, { callbacks }));
    },
  };
};

export default connect(null, mapDispatchToProps)(CreateTeamModal);
